import { addAndTrack } from "../../../calculators/helpers";
import { elmtDmgBnes } from "../../../configs";
import { findByCode } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { wpSimpleAnTmaker } from "../config";
import {
  BlackcliffSeries,
  DragonspineSeries,
  FavoniusSeries,
  RoyalSeries,
  SacrificialSeries,
  DesertSeries
} from "../series";

const PurpleCatalysts = [
  {
    code: 144,
    name: "Wandering Evenstar",
    icon: "4/44/Weapon_Wandering_Evenstar",
    pasvName: "Wildling Nightstar",
    ...DesertSeries
  },
  {
    code: 137,
    name: "Fruit of Fulfillment",
    icon: "9/98/Weapon_Fruit_of_Fulfillment",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "Energy Recharge", scale: "10%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        labels: ["Stacks"],
        inputTypes: ["stacks"],
        values: [5],
        addBnes: ({ ATTRs, wpRfm, tkDesc, inputs, tracker }) => {
          const bnValues = [(21 + wpRfm * 3) * inputs[0], -5 * inputs[0]];
          addAndTrack(
            tkDesc,
            ATTRs,
            ["Elemental Mastery", "ATK%"],
            bnValues,
            tracker
          );
        },
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 137).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Full Circle",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Obtain the "Wax and Wane" effect after an Elemental Reaction is
            triggered, gaining <Green b>{21 + wpRfm * 3}</Green>{" "}
            <Green>Elemental Mastery</Green> while losing 5% ATK. For every
            0.3s, 1 stack of Wax and Wane can be gained. Max <Green b>5</Green>{" "}
            <Green>stacks</Green>.
          </>
        ),
        others: (
          <>
            For every 6s that go by without an Elemental Reaction being
            triggered, 1 stack will be lost. This effect can be triggered even
            when the character is off-field.
          </>
        )
      }
    ]
  },
  {
    code: 123,
    name: "Oathsworn Eye",
    icon: "a/af/Weapon_Oathsworn_Eye",
    rarity: 4,
    mainStatScale: 44,
    subStat: { type: "ATK%", scale: "6%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("ATTRs", "Energy Recharge", 6),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 123).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "People of the Faltering Light",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Increases <Green>Energy Recharge</Green> by{" "}
            <Green b>{18 + wpRfm * 6}%</Green> for 10s after using an Elemental
            Skill.
          </>
        )
      }
    ]
  },
  {
    code: 37,
    name: "Wine and Song",
    icon: "c/c6/Weapon_Wine_and_Song",
    rarity: 4,
    mainStatScale: 44,
    subStat: { type: "Energy Recharge", scale: "6.7%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("ATTRs", "ATK%", 5),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 37).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Ever-Changing",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            Hitting an opponent with a Normal Attack decreases the Stamina
            consumption of Sprint or Alternate sprint by {12 + wpRfm * 2} for
            5s.
          </>
        ),
        buff: (
          <>
            Using a Sprint or Alternate Sprint ability increases{" "}
            <Green>ATK</Green> by <Green b>{15 + wpRfm * 5}%</Green> for 5s.
          </>
        )
      }
    ]
  },
  {
    code: 38,
    name: "Hakushin Ring",
    icon: "e/ee/Weapon_Hakushin_Ring",
    rarity: 4,
    mainStatScale: 44,
    subStat: { type: "Energy Recharge", scale: "6.7%" },
    buffs: [
      {
        index: 0,
        affect: "party",
        labels: ["Element"],
        inputTypes: ["choices"],
        values: [["Pyro", "Hydro", "Cryo", "Dendro", "Anemo", "Geo"]],
        addBnes: ({ ATTRs, wpRfm, inputs, charData, tkDesc, tracker }) => {
          const { vision } = charData;
          if (vision === "Electro" || vision === inputs[0]) {
            const field = vision + " DMG Bonus";
            addAndTrack(tkDesc, ATTRs, field, 7.5 + wpRfm * 2.5, tracker);
          }
        },
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 38).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Sakura Saiguu",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            After the character equipped with this weapon triggers an Electro
            elemental reaction, nearby party members of an Elemental Type
            involved in the elemental reaction receive a{" "}
            <Green b>{7.5 + wpRfm * 2.5}%</Green> Elemental DMG Bonus for{" "}
            <Green>their element</Green>, lasting 6s.
          </>
        ),
        others: <>Elemental Bonuses gained in this way cannot be stacked.</>
      }
    ]
  },
  {
    code: 39,
    name: "Royal Grimoire",
    icon: "9/99/Weapon_Royal_Grimoire",
    rarity: 4,
    mainStatScale: 44,
    subStat: { type: "ATK%", scale: "6%" },
    ...RoyalSeries
  },
  {
    code: 40,
    name: "Mappa Mare",
    icon: "4/4d/Weapon_Mappa_Mare",
    rarity: 4,
    mainStatScale: 44,
    subStat: { type: "Elemental Mastery", scale: 24 },
    buffs: [
      {
        index: 0,
        affect: "self",
        labels: ["Stacks"],
        inputTypes: ["stacks"],
        values: [2],
        addBnes: ({ ATTRs, wpRfm, inputs, tkDesc, tracker }) => {
          const bnValue = (6 + wpRfm * 2) * inputs[0];
          addAndTrack(tkDesc, ATTRs, elmtDmgBnes, bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 40).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Infusion Scroll",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Triggering an Elemental reaction grants a{" "}
            <Green b>{6 + wpRfm * 2}%</Green> <Green>Elemental DMG Bonus</Green>{" "}
            for 10s. Max <Green b>2</Green> stacks.
          </>
        )
      }
    ]
  },
  {
    code: 41,
    name: "The Widsith",
    icon: "f/f0/Weapon_The_Widsith",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "CRIT DMG", scale: "12%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        labels: ["Theme Song"],
        inputTypes: ["choices"],
        values: [["Recitative", "Aria", "Interlude"]],
        addBnes: ({ ATTRs, wpRfm, inputs, tkDesc, tracker }) => {
          if (inputs[0] === "Aria") {
            addAndTrack(tkDesc, ATTRs, elmtDmgBnes, 36 + wpRfm * 12, tracker);
          } else {
            const field =
              inputs[0] === "Recitative" ? "ATK%" : "Elemental Mastery";
            const bnValue =
              inputs[0] === "Recitative" ? 45 + wpRfm * 15 : 180 + wpRfm * 60;
            addAndTrack(tkDesc, ATTRs, field, bnValue, tracker);
          }
        },
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 41).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Debut",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            When a character takes the field, they will gain a random theme song
            for 10s. This can only occur once every 30s. Recitative:{" "}
            <Green>ATK</Green> is increased by{" "}
            <Green b>{45 + wpRfm * 15}%</Green>. Aria: increases{" "}
            <Green>all Elemental DMG</Green> by{" "}
            <Green b>{36 + wpRfm * 12}%</Green>. Interlude:{" "}
            <Green>Elemental Mastery</Green> is increased by{" "}
            <Green b>{180 + wpRfm * 60}</Green>.
          </>
        )
      }
    ]
  },
  {
    code: 42,
    name: "Frostbearer",
    icon: "1/1c/Weapon_Frostbearer",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "ATK%", scale: "9%" },
    ...DragonspineSeries
  },
  {
    code: 43,
    name: "Solar Pearl",
    icon: "f/fc/Weapon_Solar_Pearl",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "CRIT Rate", scale: "6%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", ["ES.pct", "EB.pct"], 5),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 43).pasvDescs({ wpRfm })[0].buff1
      },
      {
        index: 1,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", "NA.pct", 5),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 43).pasvDescs({ wpRfm })[0].buff2
      }
    ],
    pasvName: "Solar Shine",
    pasvDescs: ({ wpRfm }) => [
      {
        get buff() {
          return (
            <>
              {this.buff1} {this.buff2}
            </>
          );
        },
        buff1: (
          <>
            Normal Attack hits increase <Green>Elemental Skill</Green> and{" "}
            <Green>Elemental Burst DMG</Green> by{" "}
            <Green b>{15 + wpRfm * 5}%</Green> for 6s.
          </>
        ),
        buff2: (
          <>
            Likewise, Elemental Skill or Elemental Burst hits increase{" "}
            <Green>Normal Attack DMG</Green> by{" "}
            <Green b>{15 + wpRfm * 5}%</Green> for 6s.
          </>
        )
      }
    ]
  },
  {
    code: 44,
    name: "Prototype Amber",
    icon: "2/2a/Weapon_Prototype_Amber",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "HP%", scale: "9%" },
    pasvName: "Gilding",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Using an Elemental Burst regenerates{" "}
            <Green b>{3.5 + wpRfm * 0.5}</Green> <Green>Energy</Green> every 2s
            for 6s. All party members will regenerate{" "}
            <Green b>{3.5 + wpRfm * 0.5}%</Green> HP every 2s for this duration.
          </>
        )
      }
    ]
  },
  {
    code: 45,
    name: "Favonius Codex",
    icon: "3/36/Weapon_Favonius_Codex",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "Energy Recharge", scale: "10%" },
    ...FavoniusSeries
  },
  {
    code: 46,
    name: "Blackcliff Agate",
    icon: "a/a6/Weapon_Blackcliff_Agate",
    rarity: 4,
    mainStatScale: 42,
    subStat: { type: "CRIT DMG", scale: "12%" },
    ...BlackcliffSeries
  },
  {
    code: 47,
    name: "Dodoco Tales",
    icon: "5/51/Weapon_Dodoco_Tales",
    rarity: 4,
    mainStatScale: 41,
    subStat: { type: "ATK%", scale: "12%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", "CA.pct", 4),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 47).pasvDescs({ wpRfm })[0].buff1
      },
      {
        index: 1,
        affect: "self",
        addBnes: wpSimpleAnTmaker("ATTRs", "ATK%", 2),
        desc: ({ wpRfm }) =>
          findByCode(PurpleCatalysts, 47).pasvDescs({ wpRfm })[0].buff2
      }
    ],
    pasvName: "Dodoventure!",
    pasvDescs: ({ wpRfm }) => [
      {
        get buff() {
          return (
            <>
              {this.buff1} {this.buff2}
            </>
          );
        },
        buff1: (
          <>
            Normal Attack hits on opponents increase{" "}
            <Green>Charged Attack DMG</Green> by{" "}
            <Green b>{12 + wpRfm * 4}%</Green> for 6s.
          </>
        ),
        buff2: (
          <>
            Charged Attack hits on opponents increase <Green>ATK</Green> by{" "}
            <Green b>{6 + wpRfm * 2}%</Green> for 6s.
          </>
        )
      }
    ]
  },
  {
    code: 48,
    name: "Eye of Perception",
    icon: "6/6c/Weapon_Eye_of_Perception",
    rarity: 4,
    mainStatScale: 41,
    subStat: { type: "ATK%", scale: "12%" },
    pasvName: "Echo",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            Normal and Charged Attacks have a <Green>50% chance</Green> to fire
            a Bolt of Perception, dealing <Green b>{210 + wpRfm * 30}%</Green>{" "}
            <Green>ATK</Green> as DMG. This bolt can bounce between opponents a
            maximum of 4 times. This effect can occur once every{" "}
            <Green b>{13 - wpRfm}s</Green>.
          </>
        )
      }
    ]
  },
  {
    code: 49,
    name: "Sacrificial Fragments",
    icon: "6/6c/Weapon_Sacrificial_Fragments",
    rarity: 4,
    mainStatScale: 41,
    subStat: { type: "Elemental Mastery", scale: 48 },
    ...SacrificialSeries
  }
];

export default PurpleCatalysts;
